import { useMemo } from "react";

export interface JiraSourceSettingsText {
  resourceLabelText: string;
  resourcePlaceholderText: string;
  projectsLabelText: string;
  projectsPlaceholderText: string;
  projectsHintText: string;
  issueTypesLabelText: string;
  issueTypesPlaceholderText: string;
  issueTypesHintText: string;
  statusesToLoadLabelText: string;
  statusesToLoadPlaceholderText: string;
  statusesToLoadHintText: string;
  doneStatusLabelText: string;
  doneStatusPlaceholderText: string;
  doneStatusHintText: string;
  assignedToMeLabelText: string;
  assignedToMeHintText: string;
  tagsLabelText: string;
  includeProjectInTitleLabelText: string;
  includeTypeAcronymInTitleLabelText: string;
  tagsHintText: string;
  loadingText: string;
  loadErrorText: string;
  statusReferenceErrorText: string;
  notSetText: string;
}

export const useJiraSourceSettingsText = (
  t: (key: string) => string,
): JiraSourceSettingsText => {
  return useMemo(() => {
    const tKey = (key: string): string =>
      t(`board.connections.dialog.sourceSettings.jira.${key}`);

    return {
      resourceLabelText: tKey("resourceLabel"),
      resourcePlaceholderText: tKey("resourcePlaceholder"),
      projectsLabelText: tKey("projectsLabel"),
      projectsPlaceholderText: tKey("projectsPlaceholder"),
      projectsHintText: tKey("projectsHint"),
      issueTypesLabelText: tKey("issueTypesLabel"),
      issueTypesPlaceholderText: tKey("issueTypesPlaceholder"),
      issueTypesHintText: tKey("issueTypesHint"),
      statusesToLoadLabelText: tKey("statusesToLoadLabel"),
      statusesToLoadPlaceholderText: tKey("statusesToLoadPlaceholder"),
      statusesToLoadHintText: tKey("statusesToLoadHint"),
      doneStatusLabelText: tKey("doneStatusLabel"),
      doneStatusPlaceholderText: tKey("doneStatusPlaceholder"),
      doneStatusHintText: tKey("doneStatusHint"),
      assignedToMeLabelText: tKey("assignedToMeLabel"),
      assignedToMeHintText: tKey("assignedToMeHint"),
      tagsLabelText: tKey("tagsLabel"),
      includeProjectInTitleLabelText: tKey("includeProjectInTitleLabel"),
      includeTypeAcronymInTitleLabelText: tKey(
        "includeTypeAcronymInTitleLabel",
      ),
      tagsHintText: tKey("tagsHint"),
      loadingText: tKey("loading"),
      loadErrorText: tKey("loadError"),
      statusReferenceErrorText: tKey("statusReferenceError"),
      notSetText: tKey("notSet"),
    };
  }, [t]);
};
